export const NEED_TO_TALK = "Need to talk?";
export const HELP_TEXT =
  "If you are in distress or need to talk to someone about your mental wellbeing, call or text the free 24/7 mental wellbeing helpline for your country.";
export const FREE_CALL_TEXT = "Free call or text";
export const AUSTRALIA = "Australia";
export const NEW_ZEALAND = "New Zealand";
export const AUSTRALIAN_HOTLINE = "1300 22 4636";
export const NZ_HOTLINE = "1737";
export const HELP_LINE = "Help Line New Zealand and Australia";
